import { useAuthStore } from "../../store/auth.store";
import { useEffect, useState } from "react";
import { useShippingsStore } from "../../store/shippings.store";
import { useShipping } from "../../hook/partner/shippping.partner.hook";
import { PartnerApi } from "../../api/partner.api";
import { useTranslation } from "../../hooks/useTranslation";

export default function Shipping({ tracking_id, shipping_company }) {
  const { t } = useTranslation();
  const shippingMutation = useShipping();
  const token = useAuthStore((state) => state.token);
  const shipping = useShippingsStore((state) => state.shipping);

  useEffect(() => {
    if (token) {
      shippingMutation.mutate({ token, tracking_id, shipping_company });
    }
  }, [token, tracking_id, shipping_company]);

  if (shippingMutation.isLoading) return t("common.loading") + "...";

  return (
    shipping && (
      <>
        <div className="row">
          <div className="col-md-3">
            <strong>Tracking ID</strong>
            <div>{shipping.tracking_id}</div>
          </div>
          <div className="col-md-3">
            <strong>{t("shipping.carrier")}</strong>
            <div>{shipping.shipping_company}</div>
          </div>
          <div className="col-md-3">
            <strong>{t("shipping.currentStatus")}</strong>
            <div>
              {shipping.status_description}
              {shipping.status_code === "delivered" && (
                <div>
                  <span className="badge badge-success">
                    {new Date(shipping.time_of_delivery).toLocaleDateString()}
                  </span>
                </div>
              )}
            </div>
          </div>
          <div className="col-md-3">
            <strong>{t("shipping.lastUpdate")}</strong>
            <div>{new Date(shipping.last_update).toLocaleString()}</div>
          </div>
          <div className="col-md-3">
            <strong>{t("shipping.sendAddress")}</strong>
            <div>
              {shipping.origin_address_locality &&
              shipping.origin_address_locality !== ""
                ? shipping.origin_address_locality +
                  ", " +
                  shipping.origin_country_code
                : t("shipping.carrierNotSpecified")}
            </div>
          </div>
          <div className="col-md-3">
            <strong>{t("shipping.deliveryAddress")}</strong>
            <div>
              {shipping.destination_address_locality &&
              shipping.destination_address_locality !== ""
                ? shipping.destination_address_locality +
                  ", " +
                  shipping.destination_country_code
                : t("shipping.carrierNotSpecified")}
            </div>
          </div>
        </div>
        <hr />
        <h2>{t("shipping.shippingHistory")}</h2>
        <div style={{ maxHeight: "50vh", overflow: "auto" }}>
          <table className="table align-middle table-row-dashed fs-6 gy-5 dataTable">
            <thead>
              <tr>
                <th>{t("shipping.time")}</th>
                <th>{t("shipping.statusCode")}</th>
                <th>{t("common.description")}</th>
                <th>{t("shipping.location")}</th>
              </tr>
            </thead>
            <tbody>
              {shipping.history?.map((h) => (
                <tr key={h.timestamp}>
                  <td>{new Date(h.timestamp).toLocaleString()}</td>
                  <td>{h.status_code}</td>
                  <td>{h.description}</td>
                  <td>{h.location_address_locality}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </>
    )
  );
}
